module.exports = __webpack_public_path__ + "img/mkt_purchase_desktop.171d4775.svg";